import { contextTypes } from "../../../../_constants/fileUploadContextTypes";

export default function renderAdrAttachmentsV3() {
  return function (pdf) {
    if (this.imageData.length > 0) {
      this._addPage(pdf);
      let cursorY = this.cursorY;

      pdf.setFont("helvetica", "bold").setFontSize(12);
      cursorY += 15;
      pdf.text("Attachments", 302, cursorY, {
        align: "center",
      });
      cursorY += 4;
      pdf.line(15, cursorY, 590, cursorY);
      cursorY += 25;

      pdf.setFont("times", "normal").setFontSize(10);
      this.imageData.forEach((img, index) => {
        let textCursorY = cursorY + 11;
        let splitDesc = pdf
          .setFontSize(10)
          .setFont("times", "normal")
          .splitTextToSize(img.context.description, 200);
        // Render current image
        pdf.addImage(img.dataUrl, "JPEG", 50, cursorY, 200, 150);
        pdf.line(50, cursorY, 250, cursorY); // Border top
        pdf.line(250, cursorY, 250, cursorY + 150); // Border left
        pdf.line(50, cursorY + 150, 250, cursorY + 150); // Border bottom
        pdf.line(50, cursorY, 50, cursorY + 150); // Border left

        pdf
          .setFont("helvetica", "bold")
          .text("Filename:", 302, textCursorY)
          .setFont("helvetica", "normal")
          .text(img.context.fileName, 390, textCursorY);
        textCursorY += 11;
        pdf
          .setFont("helvetica", "bold")
          .text("Created On:", 302, textCursorY)
          .setFont("times", "normal")
          .text(img.context.createdOn, 390, textCursorY);
        textCursorY += 11;
        pdf
          .setFont("helvetica", "bold")
          .text("Attachment Type:", 302, textCursorY)
          .setFont("times", "normal")
          .text(img.context.attachmentType, 390, textCursorY);
        textCursorY += 11;
        pdf
          .setFont("helvetica", "bold")
          .text("Description:", 302, textCursorY)
          .setFont("times", "normal");
        splitDesc.forEach((l, index) => {
          // Keep desc to 6 lines max
          if (index < 6) {
            pdf.text(l, 390, textCursorY);
            if (index < splitDesc.length - 1) textCursorY += 11;
          }
        });
        textCursorY += 11;

        // Render context-specific info
        if (img.context.uploadContext === contextTypes.LOCWP) {
          let splitLocName = pdf
            .setFontSize(10)
            .setFont("times", "normal")
            .splitTextToSize(img.context.locationName, 200);
          let splitWpCaption = pdf
            .setFontSize(10)
            .setFont("times", "normal")
            .splitTextToSize(img.context.wpCaption, 200);

          pdf
            .setFont("helvetica", "bold")
            .text("Location:", 302, textCursorY)
            .setFont("times", "normal");
          splitLocName.forEach((l, index) => {
            pdf.text(l, 390, textCursorY);
            if (index < splitLocName.length - 1) textCursorY += 11;
          });

          textCursorY += 11;

          pdf
            .setFont("helvetica", "bold")
            .text("Performed Work:", 302, textCursorY)
            .setFont("times", "normal");
          splitWpCaption.forEach((l, index) => {
            pdf.text(l, 390, textCursorY);
            if (index < splitWpCaption.length - 1) textCursorY += 11;
          });
        }

        if (img.context.uploadContext === contextTypes.GC) {
          // let textCursorY = cursorY + 11;
          // Display any GC-specific info
        }

        // Display only 3 images per page.
        // - If the current image is not the last image on the page,
        //   add vertical margin for the next image.
        // - If the current image is the last image on the page,
        //   bring cursorY only down to the bottom of the image (so the
        //   remaining Y for the next section can be calculated correctly.)
        if ((index + 1) % 3 === 0) {
          if (index + 1 !== this.imageData.length) {
            this._addPage(pdf);
            cursorY = this.cursorY;
            pdf.setFont("helvetica", "bold").setFontSize(12);
            cursorY += 15;
            pdf.text("Attachments (Continued)", 302, cursorY, {
              align: "center",
            });
            cursorY += 4;
            pdf.line(15, cursorY, 590, cursorY);
            cursorY += 25;
          } else cursorY += 150;
        } else cursorY += 180;
      });
    }
  };
}
